// Mixed incoming/outgoing run so the placeholder reads like a conversation
// rather than a uniform block.
const BUBBLES: Array<'in' | 'out'> = ['in', 'out', 'in', 'in', 'out', 'in', 'out', 'out']

/**
 * Placeholder message bubbles for the chat history area. Shown while a
 * conversation loads — including when switching to another conversation, so
 * the previous chat's messages are never left on screen half-swapped.
 */
const ChatHistorySkeleton = () => (
  <div className="chat-skeleton chat-skeleton--history" role="status" aria-busy="true">
    <span className="visually-hidden">Loading messages...</span>
    {BUBBLES.map((side, index) => (
      <span key={index} className={`chat-skeleton__bubble chat-skeleton__bubble--${side}`} aria-hidden="true" />
    ))}
  </div>
)

export default ChatHistorySkeleton
